import React from 'react';
import BaseView from '../../components/CRUDView';
import {TractorOperatorEndpoint, TractorOwnerEndpoints} from "../../common/ProxyEndpoints";
import Utils from "../../common/Utils";
import EntityImageDisplay from "../../components/EntityImageDisplay/EntityImageDisplay";
import Avatar from '../../components/ProfileAvatar';
import {Gender, GenderMap, Permissions} from "../../common/Constants";
import DialogCollapseSection from "../../components/DialogCollapseSection/DialogCollapseSection";
import {Badge} from 'reactstrap';
import OperationSummaryComponent, {FixedValueDisplay} from "../../components/OperationSummaryComponent/OperationSummaryComponent";
import AppVariables from "../../common/AppVariables";
import {
    LicenseClasses,
    OPERATORS_QUERY_FILTERS,
    OperatorsCustomFilterView,
    parseOperatorsQueryFilters
} from "./OperatorCommon";
import RatingView from "./RatingView";
import WorkloadComponent from "../Tractors/WorkloadComponent";
import {broadcastEvent} from "../../common/Events/EventSource";
import EventActions from "../../common/Events/Actions";
import {getActiveQuantityInfo, getQuantityUnit, getQuantityValue} from "../../common/QuantityHelper";

const SearchProps = [
    'name',
    'phone',
    'address',
    'license',
    'tractor.name',
    'tractor.tractor_model',
    'tractor.chassis',
    'tractor.registration_number',
];

const CacheDependency = [
    "tractors",
    'tractor_owners',
    'dashboard'
];

/**
 * Operators - Owner View
 */
class OperatorsOwner  extends  BaseView {

    constructor(props){
        super(props,'operators_owner');
    }

    getOwnerId(){
        return this.getProxy().getUserInfo().owner.id;
    }

    /**
     * Fetches all tractors for the operator
     */
    fetchOwnerTractors(updateState = false,busyState = false){

        const ownerId = this.getOwnerId();

        if(busyState){

            this.setStateSafe({
                isBusy: true
            });

        }

        return this.proxy.processRequest( TractorOwnerEndpoints.getTractors(ownerId).url , {
            method: 'get',
            include: [{
                model: 'operator',
                attributes: ['id','name']
            }]
        } ).then(response => {

            const tractors = response.getPayload();

            if(updateState)
                this.setStateSafe({
                    tractors: tractors
                });

            if(busyState){
                this.setStateSafe({
                    isBusy: false
                })
            }

            return tractors;

        }).catch(err => {

            if(busyState){
                this.setStateSafe({
                    isBusy: false
                });
            }

            return Promise.reject(err);
        });

    }

    fetchRequests(operator,range,customRange){

        const me = this;

        this.setState({
            isBusy: true
        });

        //  get requests for operator
        return this.proxy.processRequest(TractorOperatorEndpoint.getOperationSummary(operator.id,range,customRange)).then(response => {

            operator.operationSummary = response.getPayload();

            me.setState({
                summaryError: null,
                detailItem: operator,
                isBusy: false
            });

        }).catch(err => {

            me.setState({
                isBusy: false,
                summaryError: err
            });

        });
    }

    beginShowDetails(operator){

        //  fetch requests assigned to operator
        this.fetchRequests(operator);

        //  relay to base view
        super.beginShowDetails(operator);
    }

    getCustomFilterState(filters) {
        return parseOperatorsQueryFilters(filters);
    }

    componentWillMount(){

        const me = this;
        this.setViewOptions({

            //  The message to show when there are no items in the view
            noRowsMessage: 'No tractor operators available yet!',

            //  The class icon for the card header
            pageIcon: 'fa fa-user',

            //  The title for the content frame
            pageTitle: 'Tractor Operators',

            //  The total number of items per page
            maxItemsPerPage: 10,

            //  Defines the features of the view
            features: [ 'toolbox' , 'search' ],

            multiSelection: {

                //  enable multi-selection
                enable : false,
            },

            //  defines (CRUD) actions enabled on the items
            actions:{

                //  create action options
                create: {
                    enabled: true,
                    text: 'Add Operator',
                    successCreateMsg: 'Created operator successfully!',
                    failCreateMsg : 'Failed creating operator!',
                    editTitleMsg: 'Edit Operator',
                    createTitleMsg: 'Add Operator',
                    permissions:  [ Permissions.Operators.Create ]
                },

                //  delete action options
                delete:{

                    enabled : true,

                    //  Disallows the deleting of many items ??
                    disallowMany: false,

                    //
                    successDeleteMsg: 'Deleted operator successfully!',
                    failDeleteMsg: 'Failed deleting operator',
                    text: 'Delete',
                    confirmTitle: 'Confirm Delete',
                    confirmMessage: 'Are you sure you want to delete operator?',

                    //  The message to show when deleting many items
                    confirmManyMessage: 'Delete selected operators?',
                    permissions:  [ Permissions.Operators.Remove ]
                },

                //  delete action options
                edit:{
                    enabled : true,
                    successEditMsg: 'Edited operator successfully!',
                    failEditMsg: 'Failed editing operator',
                    text: 'Edit',
                    permissions:  [ Permissions.Operators.Update ]
                }

            },

            queryActions: {
                endpoint: TractorOwnerEndpoints.getOperators(this.getOwnerId()).url,
                endpointSingle: TractorOperatorEndpoint.getUrl()
            },


            filters: Utils.excludeFilters(OPERATORS_QUERY_FILTERS,['owner.id','tractorOwnerName']),

            renderCustomFilters: (props) => <OperatorsCustomFilterView includeOwner={false} {...props}/>,

            search:{

                //
                placeholder: 'Search operators...',

                //  the mode for searching
                //  immediate: responsive
                //  explicit: wait till user hits the search button
                mode: 'explicit',

                //  The minimum characters to begin search with
                minSearchChars: 2,

                //  The search properties
                properties: SearchProps

            },

            sort: {

                properties: [
                    {
                        label: "Date Added",
                        value: "date_created"
                    },
                    {
                        label: "Name",
                        value: "name"
                    },
                    {
                        label: "Phone",
                        value: "phone"
                    }
                ]
            },

            //  Defines actions for toolbox
            toolBox: [
                {  text : 'Add Operator'  , icon : 'fa fa-plus'  , invoke: () => me.beginShowDialog({ activeDialog: 0 }) , position: 'right' , permissions:  [ Permissions.Operators.Create ] },
                {  text : 'Refresh'  , icon : 'fa fa-refresh'  ,
                    invoke: () => {

                        //  refresh view
                        me.refresh();

                        //  broadcast event for child components
                        broadcastEvent(EventActions.RefreshActivePage);

                    } ,
                    position: 'right'
                },
                {  text : 'Gender'  , icon : 'fa fa-male' , invoke: (index) => { me.updateQuery('sex',index) } , position: 'right' , group : 'filter' , items: GenderMap },
                {  text : null  , icon : 'fa fa-sort' , invoke: (index) => { me.configureSort();  }, position: 'right' , group : 'filter'},
                {  text : ''  , icon : 'fa fa-gears' , invoke: (index) => {

                        switch (index){
                            case 0:
                                return  me.toggleCustomFilterVisibility();
                        }

                    }, position: 'right' , group : 'filter' ,
                    items: () => ([
                        <span><i className={me.isCustomFilterViewVisible() ? "fa fa-chevron-up" : "fa fa-chevron-down"}/> {me.isCustomFilterViewVisible() ? "Hide" : "Show"} Advanced Filters</span>
                    ]),
                    sticky: false,
                },
            ],

            model: {
                include: [ 'owner' , 'tractor' , 'media' ]
            },

            hooks:{

                //  Called before every query to get items
                preQueryHook: () => {

                    return me.fetchOwnerTractors().then(tractors => {

                        return {
                            tractors: tractors
                        };

                    });

                },

                postProcessorHook: (action,response) =>{
                    Utils.eraseSession(CacheDependency);
                },

                renderCellActions: (item) => [
                    {
                        //  Show tractor requests
                        label: "View Requests" , icon: 'fa fa-eye' , onClick: () => {
                            return Utils.navigateLink(`/requests?tractor_operator=${encodeURIComponent(item.id.toString())}&_operator_select_name=${encodeURIComponent(item.name)}`)
                        }
                    }
                ]

            },

            //  Inputs used in editing and creating items
            inputs: [
                { name : 'name' , title: 'Name' , hint : 'Enter operator name here eg Kwame Musah' , type: 'text' , icon : 'fa fa-user' , required: true },
                { name : 'phone' , title: 'Phone Number' , hint : `Enter phone number here eg ${AppVariables.PhoneNumberExample}` , type: 'phone' , icon : 'fa fa-phone' , required: true },
                {
                    group: [
                        {   name : 'license' , title: 'License class' , hint : 'Select operator license class here...' , type: 'dropdown' , required: true ,
                            items: LicenseClasses.map(c =>{  return { name: c, text: c, value: c }; }),
                            multi: true ,
                            simple: true
                        }
                    ],
                    render: (content,key) => {

                        return (<div key={key}>
                            <DialogCollapseSection title="License" initiallyOpen={true} >
                                {content}
                            </DialogCollapseSection>
                            <hr/>
                        </div>);
                    }
                },

                { name : 'address' , title: 'Address' , hint : 'Enter operator address here' , type: 'location' , icon : 'fa fa-map-marker' , coord: {
                    lat: 'address_lat',
                    lng: 'address_long'
                }},
                { name : 'sex'  , title: 'Gender' , hint: 'Select farmer gender' , type: 'select', format: 'number' , icon : 'fa fa-user' , items: [
                    { value : Gender.Male , text: 'Male' },
                    { value : Gender.Female , text: 'Female'}
                ]},
                {
                    group: [
                        {
                            name:  'tractor' , title: 'Tractor' , type:'select' , icon : 'tractor',
                            comment: <p>Assign a tractor to the operator by selecting it below. An operator can be added without a tractor</p>,

                            refresh: () => {
                                me.fetchOwnerTractors( true , true );
                            },

                            setValue: (input,item) => {
                                input.value = item.tractor ? item.tractor.id :  '';
                            },

                            items: () => {

                                let isEditing = me.state.editItem != null;
                                let tractors = me.state.tractors || [];

                                if(isEditing){

                                    let values = [];
                                    const cTractor = me.state.editItem.tractor;
                                    if(cTractor)
                                        values = [ cTractor ];

                                    if(tractors.length > 0) {
                                        values = values.concat(tractors.filter(x => x.operator == null && (cTractor ? x.id != cTractor.id : true)));
                                    }

                                    tractors = values.map(item => {
                                        return {value: item.id, text: Utils.formatTractorName(item) }
                                    }).concat({ value: '' , text: "None" });


                                }
                                else {

                                    if(tractors.length > 0){

                                        tractors = Utils.insertNone(tractors.filter(x => x.operator == null).map((t) => {
                                            return { value: t.id , text : Utils.formatTractorName(t) }
                                        }));

                                    }

                                }

                                return tractors.length > 0 ? tractors : [{ value: '' ,text: 'None' }];
                            }
                        }
                    ],
                    render: (content,k) =>{

                        return (<div key={k}>
                            <hr/>
                            <DialogCollapseSection title={"Optional"} >
                                {content}
                            </DialogCollapseSection>
                        </div>);

                    }
                },
            ],

            // Describes the columns present in the table
            columns : [
                {key: '__img' , label: ' ' , cell: (item,k) => <Avatar media={item.media} name={Utils.formatAvatarName(item.name)} size={32} /> , mobile: true },
                {key:  'name', label: () => me.sortCol('Name','name') , mobile: true },
                {key:  'phone', label:() => me.sortCol('Phone No.','phone') , mobile: true },
                {key:  'tractor', label:'Tractor' , format: (tractor) => tractor ? Utils.formatTractorName(tractor,false,false) : <h6><Badge pill={true}>Unassigned</Badge></h6> , mobile: true  },
                {key: 'workload', label: 'Workload' , cell: item => <WorkloadComponent operator={item}/> },
            ],

            //  Describes details to show when clicked
            detailsDisplay: {

                //  enable or disable
                enabled: true,

                renderTitle: () => {
                    return "Operator Info";
                },

                renderActions: (item,  { toggle }) => ([
                    {
                        label: "View Requests" , icon: "fa fa-eye", color: "success", onClick: () => {
                            toggle();
                            return Utils.navigateLink(`/requests?tractor_operator=${encodeURIComponent(item.id.toString())}&_operator_select_name=${encodeURIComponent(item.name)}`)
                        }
                    }
                ]),

                customRender : (item) => {
                    const me = this;
                    return <div>
                        <div className="text-center">
                            <h5>Profile Image</h5>
                            <EntityImageDisplay
                                entityName="operator"
                                entityId={item.id}
                                crudView={me}
                                onRemove={(media) => {
                                    me.updateItemMedia(item,media);
                                }}
                                onCompleteUpload={(media) => {
                                    me.updateItemMedia(item,media);
                                    return false;
                                }}
                                media={item.media} />
                        </div>

                        <DialogCollapseSection title={"Info"} initiallyOpen={true}>
                            <hr/>
                            <div className="row">
                                <div className="col-md-6">
                                    <dl>
                                        <dt>Name</dt>
                                        <dl>{item.name}</dl>

                                        <dt>Phone</dt>
                                        <dl>{item.phone}</dl>

                                        <dt>License Class(es)</dt>
                                        <dl>{item.license ? item.license.split(",").sort().map((m,index) => <Badge pill={true} key={index} style={{marginRight: 5}}>{m}</Badge>) : null} </dl>

                                    </dl>
                                </div>
                                <div className="col-md-6">
                                    <dl>

                                        <dt>Gender</dt>
                                        <dl>{item.sex != null ? GenderMap[item.sex] : "N/A" }</dl>

                                        <dt>Date Registered</dt>
                                        <dl>{Utils.formatDateLong(item.date_created)}</dl>

                                        <dt>Assigned Tractor</dt>
                                        <dl>{item.tractor ? Utils.formatTractorName(item.tractor) : "N/A"}</dl>

                                    </dl>
                                </div>
                            </div>
                        </DialogCollapseSection>


                        <hr/>

                        <RatingView operatorId={item.id}/>

                        <hr/>

                        <OperationSummaryComponent
                            operationSummary={item.operationSummary}
                            onQuery={(timeRange,rangeInfo) => me.fetchRequests(item,timeRange,rangeInfo)}
                            renderRevenueStats={summary => (<div className="row">

                                <div className="col-md-6 text-center">
                                    <h6><Badge pill color={"info"}>Pending <i className="fa fa-chevron-up"/></Badge></h6>
                                    <FixedValueDisplay id="total_pending_income"
                                                       value={summary.totalPendingIncomePayout}
                                                       message={AppVariables.CurrencyCode}
                                                       hint="Indicates revenue to be generated from assigned requests"/>

                                </div>

                                <div className="col-md-6 text-center">

                                    <h6><Badge pill color={"success"}>Completed <i className="fa fa-chevron-down"/></Badge></h6>

                                    <FixedValueDisplay id="total_completed_income"
                                                       value={summary.totalIncomePayout}
                                                       message={AppVariables.CurrencyCode}
                                                       hint="Shows total revenue generated from completed requests"/>

                                </div>

                            </div>)}
                            renderOperationStats={summary => (<div className="row">

                                <div className="col-md-4 text-center">
                                    <h6><Badge pill color={"danger"}>Cancelled <i className="fa fa-close"/></Badge></h6>
                                    <FixedValueDisplay id="total_cancelled_requests"
                                                       value={summary.totalCancelledRequests}
                                                       hint="Shows to total number of requests cancelled within the given time specified"/>
                                </div>


                                <div className="col-md-4 text-center">
                                    <h6><Badge pill color={"info"}>Assigned <i className="fa fa-chevron-up"/></Badge></h6>
                                    <FixedValueDisplay id="total_assigned_acres"
                                                       value={getQuantityValue(summary,{ acre: 'totalAcresAssigned' , hectare: 'totalHectaresAssigned' })}
                                                       message={getQuantityUnit( getQuantityValue(summary,{ acre: 'totalAcresAssigned' , hectare: 'totalHectaresAssigned' }) ).toLowerCase()}
                                                       hint={`Shows total ${getActiveQuantityInfo().plural.toLowerCase()} assigned to the operator over the time range specified`}/>
                                </div>

                                <div className="col-md-4 text-center">
                                    <h6><Badge pill >Completed <i className="fa fa-chevron-down"/></Badge></h6>
                                    <FixedValueDisplay id="total_completed_acres"
                                                       value={getQuantityValue(summary,{ acre: 'totalAcresCompleted' , hectare: 'totalHectaresCompleted' })}
                                                       message={getQuantityUnit( getQuantityValue(summary,{ acre: 'totalAcresCompleted' , hectare: 'totalHectaresCompleted' }) ).toLowerCase()}
                                                       hint={`Shows completed ${getActiveQuantityInfo().plural.toLowerCase()} within specified time`}/>
                                </div>

                            </div>)}/>


                    </div>
                }

            },

            //  Processors
            processors :{

                //  create new item
                createItem: (proxy , payload ) => {

                    //  create tractor operator
                    return proxy.processRequest( TractorOperatorEndpoint.createOperator( me.getOwnerId() , payload.tractor , {
                        name: payload.name,
                        phone: payload.phone,
                        address: payload.address,
                        address_lat: payload.address_lat,
                        address_long: payload.address_long,
                        license: payload.license,
                        sex: payload.sex
                    })).then(response => this.fetchOwnerTractors(true).then(() => response));

                },

                //  called to delete many items
                deleteMany: (proxy,items) => {
                    return proxy.processRequest(TractorOperatorEndpoint.deleteOperator(items.map((item) => item.id )));
                },

                //  on edit item
                onEditItem: (proxy,item, payload , affected ) => {

                    affected.owner_id = me.getOwnerId();

                    if( (item.tractor ? item.tractor.id : null) != affected.tractor) {
                        affected.tractor_id = affected.tractor;
                    }

                    if(affected.tractor == undefined){
                        affected.tractor_id = null;
                    }

                    //  remove unwanted props
                    delete affected.tractor;

                    //  check for changed parameters
                    if(Object.keys(affected).find(x => affected[x] !== undefined)) {

                        affected.last_updated = item.last_updated;
                        return proxy.processRequest(TractorOperatorEndpoint.updateOperator(item.id, affected))
                            .then(response => this.fetchOwnerTractors(true).then(() => response));
                    }
                    else {
                        return Promise.resolve();
                    }

                },

                //  on delete item
                onDeleteItem: ( proxy,item ) => {
                    return proxy.processRequest(TractorOperatorEndpoint.deleteOperator(item.id));
                }

            }
        });
    }

}

export default OperatorsOwner;



// WEBPACK FOOTER //
// ./src/views/Operators/OperatorsOwner.js